module.exports = {
    customer: 'snappy',
    assets: { logo: 'logo.svg' }
    
};